import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LoyaltyTransaction, LoyaltyTransactionCreate, LoyaltyTransactionFilter } from '../data/loyaltyTransaction';

export function createLoyaltyTransactionService(client: AxiosInstance) {
  return createCrudService<LoyaltyTransaction, LoyaltyTransactionCreate, LoyaltyTransactionFilter>(
    client,
    '/crm/LoyaltyTransaction',
    'id',
  );
}

export type LoyaltyTransactionService = CrudService<LoyaltyTransaction, LoyaltyTransactionCreate, LoyaltyTransactionFilter>;
